import React, { useState, useEffect, useRef } from "react";
import './clinic-profile.css';
import _, { isString } from 'lodash';
import {
  Button,
  Form,
  Col,
  Row,
  Container,
  Accordion,
  Card,
} from "react-bootstrap";
import {useForm} from "react-hook-form";
import axios from 'axios';
// import { useHistory } from "react-router-dom";
import SyncLoader from "react-spinners/SyncLoader";
import GenericModal from '../../generic/modal';
import Select from 'react-select';
import {insurances_list} from '../../lists/insurance-list';
import {services_list} from '../../lists/services-list';
import {clinic_features_list} from '../../lists/clinic-features-list';
import PhoneInput from 'react-phone-input-2'
import ReactGA from 'react-ga';
// import ar from 'react-phone-input-2/lang/ar.json'
// import startsWith from 'lodash.startswith';


let autoComplete;

async function handlePlaceSelect(updateQuery, updateGeometry) {
    const addressObject = autoComplete.getPlace();
    console.log(addressObject);
    const query = addressObject.formatted_address;
    const geometry = addressObject.geometry;
    updateGeometry(geometry);
    updateQuery(query);
  }

function handleScriptLoad(updateQuery, updateGeometry, autoCompleteRef) {
    autoComplete = new window.google.maps.places.Autocomplete(
      autoCompleteRef.current,
      { types: ["address"], componentRestrictions: { country: "AE" } }
    );
    autoComplete.setFields(["address_components", "formatted_address", "geometry"]);
    autoComplete.addListener("place_changed", () =>
      handlePlaceSelect(updateQuery, updateGeometry)
    );
  }

const loadScript = (url, callback) => {
    let script = document.createElement("script");
    script.type = "text/javascript";
  
    if (script.readyState) {
      script.onreadystatechange = function() {
        if (script.readyState === "loaded" || script.readyState === "complete") {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = () => callback();
    }
  
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  };

  export default function ClinicProfile(props) {
    ReactGA.pageview(window.location.pathname + window.location.search);    
    const clinicData = props.location.state.clinicData;
    // let history = useHistory();
    const {register, handleSubmit} = useForm({
      defaultValues: {
        clinic_name:                      (clinicData.clinic_name || null),
        emirate:                          (clinicData.emirate || null),
        phone:                            (clinicData.phone || null),
        // address:                       (clinicData.address || null),
        website_url:                      (clinicData.website_url || null),
        description_general:              (clinicData.description_general || null),
        description_special:              (clinicData.description_special || null),
        description_team:                 (clinicData.description_team || null),
        practice_management_software:     (clinicData.practice_management_software || null),
      }
  });
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [success, setSuccess] = useState(Boolean);
    const [query, setQuery] = useState("");
    const [geometry, setGeometry] = useState("");
    const [phone, setPhone] = useState(clinicData.phone || '');
    const [selectedInsurances, setSelectedInsurances] = useState(clinicData.insurances || []);
    const [selectedServices, setSelectedServices] = useState(clinicData.offered_services || []);
    const [selectedFeatures, setSelectedFeatures] = useState(clinicData.features || []);
    
    const autoCompleteRef = useRef(clinicData.address);



    const handleChange = async (form, e) => {
      let value = ''
      if(e.length > 0){
        value = e[e.length-1].value;
      }
      if (form === "insurances" || insurances_list.filter(obj => obj.value === value).length > 0) {
        setSelectedInsurances(Array.isArray(e) ? e.map(x => x.value) : []);
      }
      else if (form === "services" || services_list.filter(obj => obj.value === value).length > 0) {
        setSelectedServices(Array.isArray(e) ? e.map(x => x.value) : []);
      }
      else if (form === "features" || clinic_features_list.filter(obj => obj.value === value).length > 0) {
        setSelectedFeatures(Array.isArray(e) ? e.map(x => x.value) : []);
      }      
      
    }



    useEffect(() => {
        loadScript(
          `https://maps.googleapis.com/maps/api/js?key=AIzaSyBKMzsTYEHrnlFQurwvYP2DCV0AJtM4GCY&libraries=places`,
          () => handleScriptLoad(setQuery, setGeometry, autoCompleteRef)
        );
      }, []);


    const onSubmit = async (data) => {
      data.phone = phone
      data.address = query;
      data.location = JSON.stringify(geometry.location);
      data._id = clinicData._id;
      data.insurances = selectedInsurances;
      data.offered_services = selectedServices;
      data.features = selectedFeatures;
      for (var propName in data) { 
        if (data[propName] === null || data[propName] === undefined || data[propName] === '' || data[propName] === '- Please Select -') {
          delete data[propName];
        } else if (isString(data[propName])) {
          console.log(data[propName])
          data[propName] = data[propName].trim();
        }
      }
      console.log(data);
      setLoading(true);
      const token = localStorage.getItem('token');
      const axiosConfig = {
          headers: {
              Authorization: token
          }
      };

      await axios.post('https://uae-dentist-backend.herokuapp.com/account/clinic-profile', data, axiosConfig)
      .then(function (response) {
        _.extend(props.location.state.clinicData, data);
        setSuccess(true);
        setShow(true);
        console.log(response)
        setLoading(false);
      })
      .catch(function (error) {
        setSuccess(false);
        setShow(true);
        setLoading(false);
        console.log(error);
      })
    }

    return (
    <Container className="mt-5 rounded">
    { show && <GenericModal setShow={setShow} show={show} success={success}/>}
    <Row>
    <Col id="message" className="rounded p-5 mt-2 mb-2">
        Here you can update the information displayed about your clinic.
        <br/>
        <br/>
        <h6>It's always good to stay up to date. Please update this frequently.
            <br/>
            <br/>
            Our simple service makes it easier for you to add information about your clinic - all around the clock. 
            Add your clinic today so that we can start showing it to customers.
            <br/>
            <br/>
            Welcome to AUE.dentist!
        </h6>
    </Col>
    <Col id="form" className="p-2 rounded">
    <Form onSubmit={handleSubmit(onSubmit)}>
    <Accordion defaultActiveKey="0">
      <Card>
        <Card.Header>
          <Accordion.Toggle as={Button} variant="link" eventKey="0">
            Background
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
        <Card.Body>

        <Form.Group >
            <Form.Label>Name of Clinic</Form.Label>
            <Form.Control placeholder="Please provide the name of your Clinic" name="clinic_name" ref={register}/>
        </Form.Group>

        <Form.Group >
            <Form.Label>Year Founded</Form.Label>
            <Form.Control placeholder="1990" name="year_founded" ref={register}/>
        </Form.Group>

        <Form.Group controlId="emirate">
        <Form.Label>Emirate</Form.Label>
            <Form.Control as="select" name="emirate" ref={register} custom>
            <option>- Please Select -</option>
            <option>Dubai</option>
            <option>Abu Dhabi</option>
            <option>Sharjah</option>
            <option>Ajman</option>
            <option>Fujairah</option>
            <option>Ras Al Khaimah</option>
            <option>Umm Al Quwain</option>
            </Form.Control>
        </Form.Group>

        <Form.Group controlId="description_general">
            <Form.Label>Description of Clinic</Form.Label>
            <Form.Control placeholder="Please write what makes your clinic stand out from the rest." as="textarea" rows="3" name="description_general" ref={register} />
        </Form.Group>

        <Form.Group controlId="description_special">
            <Form.Label>What makes your practice special when compared with others in the area?</Form.Label>
            <Form.Control placeholder="Please write what makes your clinic stand out from the rest." as="textarea" rows="3" name="description_special" ref={register} />
        </Form.Group>

        <Form.Group controlId="description_team">
            <Form.Label>What are you and your team proud of at your practice?</Form.Label>
            <Form.Control placeholder="Please write what makes your clinic stand out from the rest." as="textarea" rows="3" name="description_team" ref={register} />
        </Form.Group>

        </Card.Body>
        </Accordion.Collapse>
      </Card>

      <Card>
        <Card.Header>
          <Accordion.Toggle as={Button} variant="link" eventKey="1">
            Services
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey="1">
        <Card.Body>
        <Form.Group controlId="insurance">
        <Form.Label>Supported Insurances</Form.Label>
            <Select 
            value={insurances_list.filter(obj => selectedInsurances.includes(obj.value))}
            isMulti
            isClearable
            onChange={(e) => handleChange('insurances', e)}
            options = {insurances_list} 
            // value ={defaultInsurances}
            className="basic-multi-select"
            classNamePrefix="select"
            />
        </Form.Group>

        <Form.Group controlId="services">
        <Form.Label>Services Offered</Form.Label>
            <Select 
            value={services_list.filter(obj => selectedServices.includes(obj.value))}
            isMulti
            isClearable
            onChange={(e) => handleChange('services', e)}
            options = {services_list} 
            className="basic-multi-select"
            classNamePrefix="select"
            />
        </Form.Group>

        <Form.Group controlId="services">
        <Form.Label>Practice Features</Form.Label>
            <Select 
            value={clinic_features_list.filter(obj => selectedFeatures.includes(obj.value))}
            isMulti
            isClearable
            onChange={(e) => handleChange('features', e)}
            options = {clinic_features_list} 
            className="basic-multi-select"
            classNamePrefix="select"
            />
        </Form.Group>

        <Form.Group controlId="practice_management_software">
        <Form.Label>Practice Management Software</Form.Label>
            <Form.Control as="select" name="practice_management_software" ref={register} custom>
            <option disabled>- Please Select -</option>
            <option>A</option>
            <option>B</option>
            <option>C</option>
            <option>D</option>
            <option>E</option>
            <option>F</option>
            <option>G</option>
            </Form.Control>
        </Form.Group> 
        </Card.Body>
        </Accordion.Collapse>
      </Card>


      <Card>
        <Card.Header>
          <Accordion.Toggle as={Button} variant="link" eventKey="2">
            Contact Info
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey="2">
        <Card.Body>
        <Form.Group controlId="phone">
        <Form.Label>Phone Number</Form.Label>
          <PhoneInput 
            className='w-100'
            // localization={ae}
            country={'ae'}
            placeholder="Please provide your phone number" 
            value={phone}
            onChange={input => setPhone( input )}
          />
        </Form.Group>

        <Form.Group controlId="address">
            <Form.Label>Address</Form.Label>
            <Form.Control 
            placeholder={clinicData.address}
            name="address"
            ref={autoCompleteRef}
            onChange={event => setQuery(event.target.value)}
            value={query}
            />
        </Form.Group>

        <Form.Group controlId="website_url">
            <Form.Label>Website URL</Form.Label>
            <Form.Control placeholder="Please provide your clinics website address" name="website_url" ref={register} />
        </Form.Group>

        <Form.Group controlId="facebook">
            <Form.Label>Facebook</Form.Label>
            <Form.Control placeholder="www.facebook.com/profile" name="facebook" ref={register} />
        </Form.Group>

        </Card.Body>
        </Accordion.Collapse>
      </Card>
      </Accordion>
        
        <Button variant="primary" type="submit">
            Update
        </Button>
        <div className='mt-5'>
          <SyncLoader
            size={15}
            margin={2}
            color={"#123abc"}
            loading={loading}
          />
        </div>
    </Form>
    
    </Col>
    </Row>
    
    </Container>
    )
}